var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-bar',{attrs:{"background":""}},[_c('DashboardBarUser'),_c('DashboardBarDatetime'),_c('DashboardBarWeather'),_c('DashboardBarDesign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }